module.exports = __webpack_public_path__ + "img/3-2.185ed82e.svg";